<app-nav-bar [showMenu]="false"></app-nav-bar>
<div class="waitlist-container">
  <div class="content-wrapper">
    <div class="icon-wrapper">
      <i class="pi pi-thumbs-up-fill"></i>
    </div>

    <h1 class="title">Join the Waitlist</h1>

    <p class="description">
      Our journey to bring more gossip to the world.
    </p>

    <div class="form-card">
      <form [formGroup]="waitlistForm" (ngSubmit)="onSubmit()">
        <div class="form-row">
          <div class="d-flex gap-2 w-100 flex-column flex-lg-row">
            <div class="form-field">
              <label for="firstName"
                >First Name<span class="text-danger">*</span></label
              >
              <input
                id="firstName"
                type="text"
                pInputText
                formControlName="firstName"
                placeholder="Jane"
                [class.p-invalid]="isFieldInvalid('firstName')" />
              <div class="error-container">
                <small class="p-error" *ngIf="isFieldInvalid('firstName')">
                  First name is required (min 2 characters)
                </small>
              </div>
            </div>

            <div class="form-field">
              <label for="lastName"
                >Last Name<span class="text-danger">*</span></label
              >
              <input
                id="lastName"
                type="text"
                pInputText
                formControlName="lastName"
                placeholder="Doe"
                [class.p-invalid]="isFieldInvalid('lastName')" />
              <div class="error-container">
                <small class="p-error" *ngIf="isFieldInvalid('lastName')">
                  Last name is required (min 2 characters)
                </small>
              </div>
            </div>
          </div>
          <div
            @slideToggle
            *ngIf="waitlistForm.get('showOptionalFields')?.value"
            class="optional-section w-100">
            <div class="form-field w-100">
              <label for="phone">Phone<span class="text-danger">*</span></label>
              <input
                id="phone"
                type="tel"
                pInputText
                formControlName="phone"
                placeholder="Phone number"
                [class.p-invalid]="isFieldInvalid('phone')" />
              <div class="error-container">
                <small class="p-error" *ngIf="isFieldInvalid('phone')">
                  Valid Phone number is required
                </small>
              </div>
            </div>
          </div>
          <div class="form-field">
            <label for="email">Email<span class="text-danger">*</span></label>
            <input
              id="email"
              type="email"
              pInputText
              formControlName="email"
              placeholder="jane.doe@gmail.com"
              [class.p-invalid]="isFieldInvalid('email')" />
            <div class="error-container">
              <small class="p-error" *ngIf="isFieldInvalid('email')">
                Valid email is required
              </small>
            </div>
          </div>
          <div class="">
            <div class="d-flex gap-2 align-items-center">
              <input
                type="checkbox"
                id="optional-field"
                formControlName="showOptionalFields" />
              <label for="optional-field">Show additional options</label>
            </div>
          </div>
          <div
            @slideToggle
            *ngIf="waitlistForm.get('showOptionalFields')?.value"
            class="optional-section">
            <div class="d-flex gap-2 flex-column flex-lg-row">
              <div class="form-field">
                <label for="preferredContactMethod"
                  >Preferred Contact Method<span class="text-danger"
                    >*</span
                  ></label
                >
                <p-select
                  [options]="contactMethods"
                  formControlName="preferredContactMethod"
                  optionLabel="label"
                  optionValue="value"
                  [showClear]="true"
                  class="w-100"
                  placeholder="Select Contact Method"
                  [class.p-invalid]="isFieldInvalid('preferredContactMethod')">
                </p-select>
                <div class="error-container">
                  <small
                    class="p-error"
                    *ngIf="isFieldInvalid('preferredContactMethod')">
                    Contact method is required
                  </small>
                </div>
              </div>

              <div class="form-field">
                <label for="leadSource"
                  >How did you hear about us?<span class="text-danger"
                    >*</span
                  ></label
                >
                <p-select
                  [options]="leadSources"
                  formControlName="leadSource"
                  optionLabel="label"
                  optionValue="value"
                  [showClear]="true"
                  placeholder="Select Source"
                  class="w-100"
                  [class.p-invalid]="isFieldInvalid('leadSource')">
                </p-select>
                <div class="error-container">
                  <small class="p-error" *ngIf="isFieldInvalid('leadSource')">
                    Please tell us how you found us
                  </small>
                </div>
              </div>
            </div>

            <div class="form-field">
              <label for="specificQuestionsOrRequests"
                >Questions or Special Requests<span class="text-danger"
                  >*</span
                ></label
              >
              <textarea
                id="specificQuestionsOrRequests"
                pInputTextarea
                formControlName="specificQuestionsOrRequests"
                placeholder="Tell us anything you'd like us to know..."
                rows="4"
                [maxlength]="200"
                class="form-control"
                style="resize: none"
                [class.p-invalid]="
                  isFieldInvalid('specificQuestionsOrRequests')
                ">
              </textarea>
              <div class="error-container">
                <small
                  class="p-error"
                  *ngIf="isFieldInvalid('specificQuestionsOrRequests')">
                  This field is required
                </small>
              </div>
            </div>
          </div>
        </div>

          <button
          type="submit"
          pButton
          class="submit-btn"
          [disabled]="waitlistForm.invalid || isLoading()"
          >
          <span *ngIf="!isLoading()">Submit</span>
          <span *ngIf="isLoading()">
            <i class="bi bi-arrow-repeat spin me-2"></i>Submitting...
          </span>
        </button>
      </form>
    </div>

    <div class="floating-hearts">
      <span class="pi pi-thumbs-up-fill"></span>
      <span class="pi pi-thumbs-up-fill"></span>
      <span class="pi pi-thumbs-up-fill"></span>
      <span class="pi pi-thumbs-up-fill"></span>
      <span class="pi pi-thumbs-up-fill"></span>
    </div>
  </div>
</div>
<app-footer-banner></app-footer-banner>
